import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { RouterOutlet } from '@angular/router'

import { HeaderNavbarComponent } from './components/header-navbar/header-navbar.component'
import { SpinnerComponent } from './components/shared/spinner/spinner.component'
import { AuthService } from './services/auth.service'
import { NavbarComponent } from './components/navbar/navbar.component'
import { TranslationService } from './services/translation.service'
import { FooterComponent } from './components/footer/footer.component'

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    HeaderNavbarComponent,
    SpinnerComponent,
    NavbarComponent,
    FooterComponent,
  ],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private authService = inject(AuthService)

  title = inject(TranslationService).getBrandNameText()

  constructor() {
    this.authService.setIsLoggedIn()
    this.authService.setTokens(undefined)
  }
}
